export function invertSign(intAsString) {
    if (intAsString[0] === '-') {
        return intAsString.slice(1);
    } else {
        return `-${intAsString}`;
    }
}
